import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Row, Col, Collapse, Container } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import classname from "classnames";

// i18n
import { withNamespaces } from "react-i18next";

import { useSelector } from "react-redux";

const NavbarChannel = ({ location, t, menuOpen, openLeftMenuCallBack }) => {
  const [appState, setAppState] = useState(false);

  useEffect(() => {
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [location.pathname]);

  const activateParentDropdown = (item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  };

  const profile = useSelector((state) => state.profileReducer.profile);

  return (
    <React.Fragment>
      {/* Mobile Menu - Rendered outside topnav to avoid overflow issues */}
      {menuOpen && ReactDOM.createPortal(
        <div 
          className="mobile-menu-overlay"
          style={{
            position: 'fixed',
            top: '70px',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            zIndex: 9999,
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            display: 'block',
            minHeight: '200px',
            width: '100vw',
            height: '100vh'
          }}
        >
          <div style={{
            padding: '20px',
            borderBottom: '1px solid #eee',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <h5 style={{ margin: 0, color: '#333' }}>Menú de Navegación</h5>
            <button 
              onClick={openLeftMenuCallBack}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#666'
              }}
            >
              ✕
            </button>
          </div>
          
          <div style={{ padding: '20px' }}>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {/* Solicitar Certificados Section */}
              <li style={{ marginBottom: '20px' }}>
                <div style={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#666',
                  marginBottom: '10px',
                  textTransform: 'uppercase'
                }}>
                  {t("Solicitar Certificados")}
                </div>
                <Link 
                  to="/create-supply-request" 
                  onClick={openLeftMenuCallBack}
                  style={{
                    display: 'block',
                    padding: '12px 0',
                    color: '#333',
                    textDecoration: 'none',
                    fontSize: '16px',
                    borderBottom: '1px solid #eee'
                  }}
                >
                  <i className="ri-apps-2-line me-2"></i>
                  {t("Suministros")}
                </Link>
                <Link 
                  to="/create-team-request" 
                  onClick={openLeftMenuCallBack}
                  style={{
                    display: 'block',
                    padding: '12px 0',
                    color: '#333',
                    textDecoration: 'none',
                    fontSize: '16px',
                    borderBottom: '1px solid #eee'
                  }}
                >
                  <i className="ri-apps-2-line me-2"></i>
                  {t("Equipos")}
                </Link>
                <Link 
                  to="/create-special-request" 
                  onClick={openLeftMenuCallBack}
                  style={{
                    display: 'block',
                    padding: '12px 0',
                    color: '#333',
                    textDecoration: 'none',
                    fontSize: '16px',
                    borderBottom: '1px solid #eee'
                  }}
                >
                  <i className="ri-apps-2-line me-2"></i>
                  {t("Especiales")}
                </Link>
              </li>

              {/* Consultar Solicitudes Section */}
              <li style={{ marginBottom: '20px' }}>
                <div style={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#666',
                  marginBottom: '10px',
                  textTransform: 'uppercase'
                }}>
                  {t("Consultar Solicitudes")}
                </div>
                <Link 
                  to="/consult-request-channel" 
                  onClick={openLeftMenuCallBack}
                  style={{
                    display: 'block',
                    padding: '12px 0',
                    color: '#333',
                    textDecoration: 'none',
                    fontSize: '16px',
                    borderBottom: '1px solid #eee'
                  }}
                >
                  <i className="ri-search-line me-2"></i>
                  {t("Consultar Solicitudes")}
                </Link>
              </li>

              {/* Oportunidad Section */}
              <li style={{ marginBottom: '20px' }}>
                <div style={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#666',
                  marginBottom: '10px',
                  textTransform: 'uppercase'
                }}>
                  {t("Oportunidad")}
                </div>
                <Link 
                  to="/create-opportunity" 
                  onClick={openLeftMenuCallBack}
                  style={{
                    display: 'block',
                    padding: '12px 0',
                    color: '#333',
                    textDecoration: 'none',
                    fontSize: '16px',
                    borderBottom: '1px solid #eee'
                  }}
                >
                  <i className="ri-add-line me-2"></i>
                  {t("Crear Oportunidad")}
                </Link>
                <Link 
                  to="/opportunity-list" 
                  onClick={openLeftMenuCallBack}
                  style={{
                    display: 'block',
                    padding: '12px 0',
                    color: '#333',
                    textDecoration: 'none',
                    fontSize: '16px',
                    borderBottom: '1px solid #eee'
                  }}
                >
                  <i className="ri-list-check me-2"></i>
                  {t("Lista Oportunidades")}
                </Link>
              </li>

              {/* Configurador Section - Only show if user is CONNECT type */}
              {profile && profile.tipo === "CONNECT" && (
                <li style={{ marginBottom: '20px' }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#666',
                    marginBottom: '10px',
                    textTransform: 'uppercase'
                  }}>
                    {t("Configurador")}
                  </div>
                  <Link 
                    to="/create-configurator" 
                    onClick={openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-settings-3-line me-2"></i>
                    {t("Crear Configuración")}
                  </Link>
                  <Link 
                    to="/configurator-list" 
                    onClick={openLeftMenuCallBack}
                    style={{
                      display: 'block',
                      padding: '12px 0',
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <i className="ri-list-check me-2"></i>
                    {t("Lista Configuraciones")}
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>,
        document.body
      )}
      
      <div className="topnav">
        <Container fluid>
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            {/* Desktop Menu */}
            <Collapse
              isOpen={true}
              className="navbar-collapse d-none d-lg-block"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                <li className="nav-item dropdown">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      setAppState(!appState);
                    }}
                    className="nav-link dropdown-toggle arrow-none"
                    to="/#"
                    id="topnav-canales"
                    role="button"
                  >
                    <i className="ri-apps-2-line me-2"></i>{" "}
                    {t("Solicitar Certificados")}{" "}
                    <div className="arrow-down"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu dropdown-menu-end", {
                      show: appState,
                    })}
                    aria-labelledby="topnav-canales"
                  >
                    <Link to="/create-supply-request" className="dropdown-item">
                      {t("Suministros")}
                    </Link>
                    <Link to="/create-team-request" className=" dropdown-item">
                      {t("Equipos")}
                    </Link>
                    <Link
                      to="/create-special-request"
                      className="dropdown-item"
                    >
                      {t("Especiales")}
                    </Link>
                  </div>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/consult-request-channel"
                    className="nav-link dropdown-toggle arrow-none"
                    id="topnav-uielement"
                  >
                    {t("Consultar Solicitudes")}
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      setAppState(!appState);
                    }}
                    className="nav-link dropdown-toggle arrow-none"
                    to="/#"
                    id="topnav-apps"
                    role="button"
                  >
                    <i className="ri-apps-2-line me-2"></i>
                    {t("Oportunidad")} <div className="arrow-down"></div>
                  </Link>

                  <div
                    className={classname("dropdown-menu dropdown-menu-end", {
                      show: appState,
                    })}
                    aria-labelledby="topnav-canales"
                  >
                    <Link to="/create-opportunity" className="dropdown-item">
                      {t("Crear Oportunidad")}
                    </Link>
                    <Link to="/opportunity-list" className="dropdown-item">
                      {t("Lista Oportunidades")}
                    </Link>
                  </div>
                </li>

                {profile && profile.tipo === "CONNECT" && (
                  <li className="nav-item dropdown">
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        setAppState(!appState);
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                      to="/#"
                      id="topnav-apps"
                      role="button"
                    >
                      <i className="ri-apps-2-line me-2"></i>
                      {t("Configurador")} <div className="arrow-down"></div>
                    </Link>

                    <div
                      className={classname("dropdown-menu dropdown-menu-end", {
                        show: appState,
                      })}
                      aria-labelledby="topnav-canales"
                    >
                      <Link to="/create-configurator" className="dropdown-item">
                        {t("Crear Configuración")}
                      </Link>
                      <Link to="/configurator-list" className="dropdown-item">
                        {t("Lista Configuraciones")}
                      </Link>
                    </div>
                  </li>
                )}
              </ul>
            </Collapse>
            
            {/* Mobile Menu */}
            {menuOpen && (
              <div
                className="navbar-collapse d-lg-none"
                id="topnav-menu-content-mobile"
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  backgroundColor: 'white',
                  zIndex: 1000,
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  display: 'block'
                }}
              >
                <ul className="navbar-nav">
                  <li className="nav-item dropdown">
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        setAppState(!appState);
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                      to="/#"
                      id="topnav-canales-mobile"
                      role="button"
                    >
                      <i className="ri-apps-2-line me-2"></i>{" "}
                      {t("Solicitar Certificados")}{" "}
                      <div className="arrow-down"></div>
                    </Link>
                    <div
                      className={classname("dropdown-menu dropdown-menu-end", {
                        show: appState,
                      })}
                      aria-labelledby="topnav-canales-mobile"
                    >
                      <Link to="/create-supply-request" className="dropdown-item">
                        {t("Suministros")}
                      </Link>
                      <Link to="/create-team-request" className=" dropdown-item">
                        {t("Equipos")}
                      </Link>
                      <Link
                        to="/create-special-request"
                        className="dropdown-item"
                      >
                        {t("Especiales")}
                      </Link>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      to="/consult-request-channel"
                      className="nav-link dropdown-toggle arrow-none"
                      id="topnav-uielement-mobile"
                    >
                      {t("Consultar Solicitudes")}
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        setAppState(!appState);
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                      to="/#"
                      id="topnav-apps-mobile"
                      role="button"
                    >
                      <i className="ri-apps-2-line me-2"></i>
                      {t("Oportunidad")} <div className="arrow-down"></div>
                    </Link>

                    <div
                      className={classname("dropdown-menu dropdown-menu-end", {
                        show: appState,
                      })}
                      aria-labelledby="topnav-canales-mobile"
                    >
                      <Link to="/create-opportunity" className="dropdown-item">
                        {t("Crear Oportunidad")}
                      </Link>
                      <Link to="/opportunity-list" className="dropdown-item">
                        {t("Lista Oportunidades")}
                      </Link>
                    </div>
                  </li>

                  {profile && profile.tipo === "CONNECT" && (
                    <li className="nav-item dropdown">
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          setAppState(!appState);
                        }}
                        className="nav-link dropdown-toggle arrow-none"
                        to="/#"
                        id="topnav-apps-mobile"
                        role="button"
                      >
                        <i className="ri-apps-2-line me-2"></i>
                        {t("Configurador")} <div className="arrow-down"></div>
                      </Link>

                      <div
                        className={classname("dropdown-menu dropdown-menu-end", {
                          show: appState,
                        })}
                        aria-labelledby="topnav-canales-mobile"
                      >
                        <Link to="/create-configurator" className="dropdown-item">
                          {t("Crear Configuración")}
                        </Link>
                        <Link to="/configurator-list" className="dropdown-item">
                          {t("Lista Configuraciones")}
                        </Link>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            )}
          </nav>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(withNamespaces()(NavbarChannel));
